import React from 'react';

const MonthlyReport = ({ monthlyStats }) => {
  return (
    <div>
      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>📅 Statystyki miesięczne</h5>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {monthlyStats?.data && monthlyStats.data.length > 0 ? (
              <div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.75rem' }}>Miesiąc</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.75rem' }}>Liczba transakcji</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.75rem' }}>Przychód</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.75rem' }}>Średnia paragonu</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.75rem' }}>Sprzedane produkty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthlyStats.data.map((month, index) => {
                        const monthNames = [
                          'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
                          'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
                        ];
                        const monthName = monthNames[month.month_num - 1];

                        return (
                          <tr key={index}>
                            <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--bg)', fontWeight: '600' }}>{monthName} {month.year}</td>
                            <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--bg)' }}>{month.transactions_count}</td>
                            <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--bg)' }}>{parseFloat(month.total_revenue || 0).toFixed(2)} zł</td>
                            <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--bg)', color: 'var(--info)', fontWeight: '600' }}>{parseFloat(month.average_transaction || 0).toFixed(2)} zł</td>
                            <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--bg)' }}>{month.items_sold}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Wykres lub podsumowanie */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginTop: '0.75rem' }}>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--success)' }}>
                      {monthlyStats.data.reduce((sum, month) => sum + month.transactions_count, 0)}
                    </h4>
                    <small style={{ fontSize: '0.75rem' }}>Wszystkie transakcje</small>
                  </div>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>
                      {parseFloat(monthlyStats.data.reduce((sum, month) => sum + parseFloat(month.total_revenue || 0), 0)).toFixed(2)} zł
                    </h4>
                    <small style={{ fontSize: '0.75rem' }}>Całkowity przychód</small>
                  </div>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>
                      {(() => {
                        const totalRevenue = monthlyStats.data.reduce((sum, month) => sum + parseFloat(month.total_revenue || 0), 0);
                        const totalTransactions = monthlyStats.data.reduce((sum, month) => sum + parseFloat(month.transactions_count || 0), 0);
                        return (totalTransactions > 0 ? totalRevenue / totalTransactions : 0).toFixed(2);
                      })()} zł
                    </h4>
                    <small style={{ fontSize: '0.75rem' }}>Średnia wszystkich miesięcy</small>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Brak danych miesięcznych</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyReport;
